const oVideosData = [
	{
		id: 1,
		idText: "CONOCE NUESTRO PORTAL",
		menu: "Conoce nuestro Portal Soy Cliente",
		titulo: "Conoce nuestro Portal Soy Cliente",
		subtitulo: "Portal Soy Cliente es una plataforma digital que tu Seguro GNP te brinda en donde encontrarás diversos servicios en línea.",
		imagen: require("../img/bg-video-1.png"),
		video: "Promocional_SoyCliente_Actualizacion022019.mp4",
	}, {
		id: 7,
		idText: "App Soy Cliente GNP",
		menu: "Conoce nuestra App Soy Cliente GNP",
		titulo: "Conoce nuestra App Soy Cliente GNP",
		subtitulo: "Tu Seguro GNP siempre va contigo a través de la App Soy Cliente GNP, puedes consultar información de tu Póliza, reportar un siniestro, solicitar asistencia vial y mucho más.",
		imagen: require("../img/bg-video-2.jpg"),
		video: "Promocional_GNPMovil.mp4"
	}, {
		id: 19,
		idText: "ACTUALIZAR REGISTRO Y CONTRASEÑA",
		menu: "Actualizar registro y contraseña",
		titulo: "¿Cómo actualizo mi registro y contraseña?",
		subtitulo: "Actualiza tu registro y contraseña desde gnp.com.mx sección Soy Cliente y la App Soy Cliente GNP.",
		imagen: require("../img/bg-video-14.png"),
		video: "Tutorial_ActualizarRegistro-Actualizacion2019.mp4"
	}, {
		id: 18,
		idText: "REGISTRO NUEVO",
		menu: "Registro de nuevo usuario",
		titulo: "¿Cómo me registro en Soy Cliente y en la aplicación Soy Cliente GNP?",
		subtitulo: "Comienza a disfrutar los beneficios de las plataformas digitales de tu Seguro GNP registrándote fácilmente.",
		imagen: require("../img/bg-video-13.png"),
		video: "Tutorial_RegistroNuevo-Actualizacion2019.mp4"
	}, {
		id: 16,
		idText: "VIDA INVERSIÓN",
		menu: "Ingreso a Vida Inversión, Elige y Consolida Total",
		titulo: "¿Cómo ingreso ahora a mi portal Vida Inversión, Elige y Consolida Total?",
		subtitulo: "Ingresa para consultar tu Póliza desde gnp.com.mx en la sección Soy Cliente.",
		imagen: require("../img/bg-video-11.png"),
		video: "IngresoAVidaInversionEligeYConsolidaTotal2019.mp4"
	}, {
		id: 2,
		idText: "CONSULTAR POLIZAS",
		menu: "Consultar Pólizas",
		titulo: "¿Dónde puedo consultar en línea mi Póliza de Seguro?",
		subtitulo: "Visualiza todas tus Pólizas de GNP en el momento que tú quieras desde Portal Soy Cliente o la App Soy Cliente GNP.",
		imagen: require("../img/bg-video-4.png"),
		video: "Tutorial_ConsultarPolizas-Actualizacion2019.mp4"
	}, {
		id: 5,
		idText: "BOTÓN SOS",
		menu: "Botón SOS",
		titulo: "¿Cómo reporto un siniestro con la App Soy Cliente GNP?",
		subtitulo: "Solicita la asistencia de un ajustador reportando tu siniestro de manera fácil y rápida a través de la App Soy Cliente GNP",
		imagen: require("../img/bg-video-7.png"),
		video: "Tutorial_BotonSOS-Actualizacion2019.mp4"
	}, {
		id: 3,
		idText: "ACCESO COMPARTIDO",
		menu: "Acceso Compartido",
		titulo: "¿Cómo puedo compartir con otra persona mis servicios del Portal Soy Cliente y la App Soy Cliente GNP?",
		subtitulo: "Comparte los servicios y beneficios del Portal Soy Cliente y la App Soy Cliente GNP con otro conductor.",
		imagen: require("../img/bg-video-5.png"),
		video: "Tutorial_AccesoCompartido-Actualizacion2019.mp4"
	}, {
		id: 4,
		idText: "SEGUIMIENTO A LA REPARACIÓN",
		menu: "Seguimiento al estatus de reparación de Autos",
		titulo: "¿Dónde puedo consultar el proceso de reparación de mi Auto?",
		subtitulo: "Consulta fácilmente el estatus en el que se encuentra la reparación de tu Auto desde el Portal Soy Cliente y la App Soy Cliente GNP.",
		imagen: require("../img/bg-video-6.png"),
		video: "Tutorial_EstatusDeLaReparacion-Actualizacion2019.mp4"
	}, {
		id: 6,
		idText: "REEMBOLSO GASTOS MÉDICOS MAYORES",
		menu: "Consultar reembolso de Gastos Médicos Mayores",
		titulo: "¿Dónde puedo consultar el estatus de mi reembolso de Gastos Médicos Mayores?",
		subtitulo: "Si solicitaste un reembolso de Gastos Médicos Mayores, consulta el estatus desde Portal Soy Cliente y la App Soy Cliente GNP.",
		imagen: require("../img/bg-video-8.png"),
		video: "Tutorial_ReembolsoGMM-Actualizacion2019.mp4"
	}, {
		id: 17,
		idText: "MEDIOS DE NOTIFICACIÓN OTP",
		menu: "Cambio de medios de notificación",
		titulo: "¿Cómo cambio mi número de celular o correo electrónico registrado en Soy Cliente o en la aplicacoión Soy Cliente GNP?",
		subtitulo: "Mantén fácilmente actualizados tus datos de contacto registrados en Portal Soy Cliente y la App Soy Cliente GNP.",
		imagen: require("../img/bg-video-12.png"),
		video: "Tutorial_Mediodenotificacion-Actualizacion2019.mp4"
	}, {
		id: 42,
		idText: "RECUPERAR CONTRASEÑA",
		menu: "Recuperar contraseña",
		titulo: "¿Cómo puedo recuperar mi contraseña?",
		subtitulo: "Si olvidaste tu contraseña, puedes recuperarla fácilmente por medio de tu correo electrónico.",
		imagen: require("../img/bg-video-3.png"),
		video: "Tutorial_RecuperarContrasen%CC%83a-Actualizacio%CC%81n2019.mp4"
	}, {
		id: 21,
		idText: "NIP",
		menu: "Número de cliente y NIP Línea GNP",
		titulo: "¿Cómo obtengo mi número de cliente y NIP para Línea GNP?",
		subtitulo: "Tu número de cliente y NIP son necesarios para realizar todas tus operaciones y consultas de forma segura a través de Línea GNP.",
		imagen: require("../img/bg-video-9.png"),
		video: "Tutorial_CambiosLineaGNP02-Actualizacion2019.mp4"
	}, {
		id: 20,
		idText: "PORTAL CAPITALIZA",
		menu: "Ingreso a Portal Capitaliza",
		titulo: "¿Cómo ingreso a mi Póliza Capitaliza?",
		subtitulo: "Ingresa al portal de tu Póliza de Seguro Capitaliza a través de gnp.com.mx sección Soy Cliente",
		imagen: require("../img/bg-video-15.jpg")
	}, {
		id: 15,
		idText: "PAGO EN LÍNEA",
		menu: "Pago en línea",
		titulo: "¿Puedo pagar en línea mi Póliza de Seguro?",
		subtitulo: "Desde gnp.com.mx sección Soy Cliente, puedes realizar el pago de tu Póliza de Seguro con cargo a tu tarjeta de crédito o débito.",
		imagen: require("../img/bg-video-16.jpg"),
		video: "Tutorial_PagoEnLinea-Actualizacion2019.mp4"
	}, {
		id: 9,
		idText: "HISTÓRICO DE PAGOS",
		menu: "Histórico de pagos",
		titulo: "¿Cómo puedo consultar el histórico de pagos de mi Póliza de Seguro?",
		subtitulo: "A través del Portal Soy Cliente puedes consultar el historial de tus últimos 10 pagos realizados en línea, de cualquier Seguro que tengas con GNP.",
		imagen: require("../img/bg-video-17.jpg")
	}, {
		id: 26,
		idText: "DESCARGAR FACTURAS",
		menu: "Descargar facturas",
		titulo: "¿Cómo puedo descargar las Facturas de mi Póliza de Seguro en el Portal Soy Cliente?",
		subtitulo: "Desde tu Portal Soy Cliente puedes descargar rápidamente las facturas de tu Seguro GNP.",
		imagen: require("../img/bg-video-18.jpg")
	}, {
		id: 27,
		idText: "DESCARGAR CONSTANCIAS DE RETENCIONES",
		menu: "Descargar Constancias de Retenciones",
		titulo: "¿Cómo descargo la constancia de retenciones de mi Seguro?",
		subtitulo: "Desde tu Portal Soy Cliente puedes descargar en el momento que tu decidas la constancia de retenciones de tu Seguro GNP.",
		imagen: require("../img/bg-video-27.png")
	}, {
		id: 23,
		idText: "GUARDAR CAMBIOS",
		menu: "Guardar documentos",
		titulo: "¿Cómo puedo guardar mis documentos en la App Soy Cliente GNP?",
		subtitulo: "Guarda fácilmente tu INE, licencia y tarjeta de circulación en la App Soy Cliente GNP para tenerlos siempre a la mano.",
		imagen: require("../img/bg-video-19.jpg")
	}, {
		id: 25,
		idText: "DESCARGAR TRAMITES",
		menu: "Descargar formatos para trámites",
		titulo: "¿Dónde puedo consultar y descargar formatos para realizar trámites de mi Seguro GNP?",
		subtitulo: "Desde tu Portal Soy Cliente, es muy fácil realizarlo.",
		imagen: require("../img/bg-video-8.jpg")
	}, {
		id: 24,
		idText: "DIRECTORIO",
		menu: "Consultar directorio",
		titulo: "¿Cuáles son los hospitales y médicos en convenio con GNP que mi Póliza de Seguro me brinda?",
		subtitulo: "Dentro de tu Portal Soy Cliente podrás consultar el directorio de los diferentes servicios que tu Seguro GNP te brinda.",
		imagen: require("../img/bg-video-20.jpg")
	}, {
		id: 22,
		idText: "SERVICIO PUBLICOS",
		menu: "Servicios Públicos",
		titulo: "¿Cuáles son los servicios que GNP me brinda en línea?",
		subtitulo: "Tu Seguro GNP tiene servicios en línea para que tu experiencia como Asegurado sea más sencilla.",
		imagen: require("../img/bg-video-21.jpg")
	}
];
export default oVideosData;



// WEBPACK FOOTER //
// ./src/gnp-servicios/gnp-videos-datos.js